import React from "react";
import StoreSearchResult from "../types/StoreSearchResult";
import SearchResultCard from "./SearchResultCard";
import {useSelector} from "react-redux";
import {RootState} from "../store";

interface StoreSearchResultsProps {
    searchResults: StoreSearchResult[];
}

const SearchResults: React.FC<StoreSearchResultsProps> = (props) => {

    const searchRadiusInMiles = useSelector((state: RootState) => state.storeSearchCircleSlice.searchCircleRadiusInMiles);

    const searchRadiusInKm = searchRadiusInMiles? Math.round((searchRadiusInMiles * 1.60934) * 100) / 100 : undefined;

    return (
        <div className="blj-store-locator-results">
            {props.searchResults.length > 0 && searchRadiusInMiles && searchRadiusInKm && (
                <h6 className="blj-store-locator-results__title">
                    {`Found ${props.searchResults.length} Stores within ${searchRadiusInMiles} miles (${searchRadiusInKm} km)`}
                </h6>
            )}

            {props.searchResults.length === 0 ? (
                <h6 className="blj-store-locator-results__title">
                    No stores found
                </h6>
            ) : (
                <ul className="blj-store-locator-results-list">
                    {props.searchResults.map((storeSearchResultItem, index) => (
                        <SearchResultCard
                            key={index}
                            storeSearchResult={storeSearchResultItem}
                        />
                    ))}
                </ul>
            )}

        </div>
    );
}

export default SearchResults;